module.exports = {
    BASE_URL: "https://us-central1-helice-63b16.cloudfunctions.net",
    firebaseConfig: {
        apiKey: "AIzaSyDaNjTA8azVqqxyI7wmEpJlGVNSEz2t__E",
        authDomain: "helice-63b16.firebaseapp.com",
        databaseURL: "https://helice-63b16.firebaseio.com",
        projectId: "helice-63b16",
        storageBucket: "helice-63b16.appspot.com",
        messagingServerId: "716041150897"
    },
    MAPS_KEY: 'AIzaSyBRt5tonSSUXJvKCIu4eZhDsjn8mEMOMl8'
}